import React, { FC } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import InfoToolTip from '../../../@shared/infoToolTip';
import { TMsrpBlock } from '../../types/productModelsListing.types';

const MsrpBlock: FC<TMsrpBlock> = ({ msrp, t }) => {
  if (!msrp) return null;
  return (
    <>
      <span>
        {t('cnhi-startingFrom')} <RichText field={{ value: msrp }} className="product-card__msrp" />
      </span>
      {t('cnhi-MsrpTooltipTitle') || t('cnhi-MsrpTooltipDescription') ? (
        <InfoToolTip showIcon={true} clickPreventDefault={true}>
          <div className="product-card__disclaimer">
            {t('cnhi-MsrpTooltipTitle') && <div className="product-card__disclaimer__title">{t('cnhi-MsrpTooltipTitle')}</div>}
            {t('cnhi-MsrpTooltipDescription') && <div>{t('cnhi-MsrpTooltipDescription')}</div>}
          </div>
        </InfoToolTip>
      ) : null}
    </>
  );
};

export default MsrpBlock;
